/** Fired after ERP embed JWT is persisted so AuthContext can rehydrate outside Router. */
export const RAPTOR_EMBED_TOKEN_READY = 'raptor:embed-token-ready';

export function notifyEmbedTokenReady(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(RAPTOR_EMBED_TOKEN_READY));
}
